import { ButtonProps } from "primereact/button";
import { stockTypes } from "../types/stockTypes";
import { ColumnProps } from "primereact/column";
import { StockCode } from "../types/assetTypes";
type StockRow = {
  total_price: number;
  currency: string;
};

export const stockCodeBodyTableIcon = (
  handleEditStockCode: (stockCodeId: number) => void,
  handleDeleteStock: (stockCodeId: number) => void,



  rowData: stockTypes
): ButtonProps[] => [
    {
      icon: "pi pi-pencil",
      rounded: true,
      outlined: true,
      className: "mr-2",
      onClick: () => handleEditStockCode(rowData.stockCodeId),
      title: "Edit Asset",
    },




  ];
export const stockBodyTableIcon = (
  handleEditStock: (stockId: number) => void,
  handleDeleteStock: (stockId: number) => void,



  rowData: stockTypes
): ButtonProps[] => [


  ];

export const stockBodyTable = (
  handleEditStock: (stockId: number) => void,
  handleDeleteStock: (stockId: number) => void,

  rowData: stockTypes,
  openVisibilityPopover: (event: React.MouseEvent<HTMLElement>) => void // <-- Add this  
): ButtonProps[] => [

  ];


export const getStockColumns = (
  actionBodyTemplate: (rowData: stockTypes) => JSX.Element,
  actionPicTemplate: (rowData: any) => JSX.Element,

): ColumnProps[] => [
    {
      selectionMode: "multiple",
      exportable: false,
    },
    {
      field: "stockAttachmentId",
      header: "Image",
      sortable: false,
      filter: false,
      body: actionPicTemplate,
    },
    {
      field: "stockCode",
      header: "Stock Code",
      sortable: true,
      filter: false,
      filterField: "stockCode",
      filterPlaceholder: "Search",
    },
    {
      field: "stock_description",
      header: "Item Description",
      sortable: true,
      filter: false,
      filterField: "stock_description",
      filterPlaceholder: "Search",
    },
    {
      field: "location_name",
      header: "Country",
      sortable: true,
      filter: false,
      filterField: "location_name",
      filterPlaceholder: "Search",
    },
    {
      field: "localStore",
      header: "Local Stores",
      sortable: true,
      filter: false,
      filterField: "localStore",
      filterPlaceholder: "Search",
    },
    {
      field: "original_mfg",
      header: "Original Mfg",
      sortable: true,
      filter: false,
      filterField: "original_mfg",
      filterPlaceholder: "Search",
    },
    {
      field: "model_part_no",
      header: "Model/Part no",
      sortable: true,
      filter: false,
      filterField: "model_part_no",
      filterPlaceholder: "Search",
    },
    {
      field: "stock_category",
      header: "Stock Category",
      sortable: true,
      filter: false,
      filterField: "stock_category",
      filterPlaceholder: "Search",
    },
    {
      field: "used_for_mfg",
      header: "Used for - Mfg",
      sortable: false,
      filter: false,
      body: (rowData: any) => rowData.used_for_mfg || "-", // Show value or fallback
    },
    {
      field: "used_for_model",
      header: "Used for - Model",
      sortable: false,
      filter: false,
      body: (rowData: any) => rowData.used_for_model || "-", // Show value or fallback
    },

    {
      field: "supplier",
      header: "Supplier",
      sortable: true,
      filter: false,
      filterField: "supplier",
      filterPlaceholder: "Search",
    },
    {
      field: "location",
      header: "Rack Location",
      sortable: true,
      filter: false,
      filterField: "location",
      filterPlaceholder: "Search",
    },
    {
      field: "currentStock",
      header: "Current Stock",
      sortable: true,
      filter: false,
      filterField: "currentStock",
      filterPlaceholder: "Search",
    },
    {
      field: "qty",
      header: "Qty",
      sortable: true,
      filter: false,
      filterField: "qty",
      filterPlaceholder: "Search",
    },
    {
      field: "unit_price",
      header: "Unit Price",
      sortable: true,
      filter: false,
      filterField: "unit_price",
      filterPlaceholder: "Search",
    },
    {
      field: "total_price",
      header: "Total Price",
      sortable: true,
      filter: false,
      filterField: "total_price",
      filterPlaceholder: "Search",
    },

    {
      field: "currency",
      header: "Currency",
      sortable: true,
      filter: false,
      filterField: "currency",
      filterPlaceholder: "Search",
    },


  ];


export const getStockColumnnns = (
  actionBodyTemplate: (rowData: stockTypes) => JSX.Element,
  actionPicTemplate: (rowData: any) => JSX.Element,
  selectedCurrency: string,
  exchangeRates: Record<string, number>,
  setSelectedCurrency: (val: string) => void
): ColumnProps[] => [
    {
      selectionMode: "multiple",
      exportable: false,
    },
    {
      field: "stockAttachmentId",
      header: "Image",
      sortable: false,
      filter: false,
      body: actionPicTemplate,
    },
    {
      field: "stockCode",
      header: "Stock Code",
      sortable: true,
      filter: false,
      filterField: "stockCode",
      filterPlaceholder: "Search",
    },
    {
      field: "stock_description",
      header: "Item Description",
      sortable: true,
      filter: false,
      filterField: "stock_description",
      filterPlaceholder: "Search",
    },
    {
      field: "location_name",
      header: "Country",
      sortable: true,
      filter: false,
      filterField: "location_name",
      filterPlaceholder: "Search",
    },
    {
      field: "localStore",
      header: "Local Stores",
      sortable: true,
      filter: false,
      filterField: "localStore",
      filterPlaceholder: "Search",
    },
    {
      field: "original_mfg",
      header: "Original Mfg",
      sortable: true,
      filter: false,
      filterField: "original_mfg",
      filterPlaceholder: "Search",
    },
    {
      field: "model_part_no",
      header: "Model/Part no",
      sortable: true,
      filter: false,
      filterField: "model_part_no",
      filterPlaceholder: "Search",
    },
    {
      field: "stock_category",
      header: "Stock Category",
      sortable: true,
      filter: false,
      filterField: "stock_category",
      filterPlaceholder: "Search",
    },
    {
      field: "used_for_mfg",
      header: "Used for - Mfg",
      sortable: false,
      filter: false,
      body: (rowData: any) => rowData.used_for_mfg || "-", // Show value or fallback
    },
    {
      field: "used_for_model",
      header: "Used for - Model",
      sortable: false,
      filter: false,
      body: (rowData: any) => rowData.used_for_model || "-", // Show value or fallback
    },

    {
      field: "supplier",
      header: "Supplier",
      sortable: true,
      filter: false,
      filterField: "supplier",
      filterPlaceholder: "Search",
    },
    {
      field: "location",
      header: "Rack Location",
      sortable: true,
      filter: false,
      filterField: "location",
      filterPlaceholder: "Search",
    },
    {
      field: "currentStock",
      header: "Current Stock",
      sortable: true,
      filter: false,
      filterField: "currentStock",
      filterPlaceholder: "Search",
    },
    {
      field: "qty",
      header: "Qty",
      sortable: true,
      filter: false,
      filterField: "qty",
      filterPlaceholder: "Search",
    },
    {
      field: "unit_price",
      header: "Unit Price",
      sortable: true,
      filter: false,
      filterField: "unit_price",
      filterPlaceholder: "Search",
    },
    {
      field: "total_price",
      header: "Total Price",
      sortable: true,
      filter: false,
      filterField: "total_price",
      filterPlaceholder: "Search",
    },

    {
      field: "currency",
      header: "Currency",
      sortable: true,
      filter: false,
      filterField: "currency",
      filterPlaceholder: "Search",
    },

    {
      field: "converted_price",
      header: () => (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <strong>Convert to</strong>
          <select
            value={selectedCurrency}
            onChange={(e) => setSelectedCurrency(e.target.value)}
            style={{ fontSize: "0.8rem", marginTop: "4px" }}
          >
            {Object.keys(exchangeRates).map((cur) => (
              <option key={cur} value={cur}>
                {cur}
              </option>
            ))}
          </select>
        </div>
      ),
      body: (rowData: StockRow) => {
        const from = rowData.currency?.trim();
        const to = selectedCurrency;
        const amount = parseFloat(rowData.total_price?.toString() ?? "0");

        const fromRate = exchangeRates[from];
        const toRate = exchangeRates[to];

        if (!fromRate || !toRate || isNaN(amount)) return "-";

        const converted = (amount / fromRate) * toRate;
        return `${converted.toFixed(2)} ${to}`;
      },
      sortable: false,
      filter: false,
    },




  ];

export const getStockTransactionColumns = (
  actionBodyTemplate: (rowData: any) => JSX.Element,
  actionPicTemplate: (rowData: any) => JSX.Element
): ColumnProps[] => [
    {
      selectionMode: "multiple",
      exportable: false,
    },
    {
      field: "stockCodeAttachmentId",
      header: "Image",
      sortable: false,
      filter: false,
      body: actionPicTemplate,
    },
    {
      field: "transactionType",
      header: "Transaction Type",
      sortable: true,
      filter: true,
    },
    {
      field: "categoryType",
      header: "Category Type",
      sortable: true,
      filter: true,
    },
    {
      field: "stockCode",
      header: "Stock Code",
      sortable: true,
      filter: true,
    },
    {
      field: "description",
      header: "Description",
      sortable: true,
      filter: true,
    },
    {
      field: "qty",
      header: "Transaction Quantity",
      sortable: true,
      filter: true,
    },
    {
      field: "locationInfo.currentLocationName",
      header: "From Country",
      sortable: true,
      filter: false,
      body: (rowData: any) => rowData.locationInfo?.currentLocationName || "-",
    },

    // 📌 Store Info
    {
      field: "storeName",
      header: "From Store",
      sortable: true,
      filter: true,
    },
    {
      field: "toStoreName",
      header: "To Store",
      sortable: true,
      filter: true,
    },

    {
      field: "currentStock",
      header: "Stock Before Transaction",
      sortable: true,
      filter: true,
    },
    {
      field: "stockAfterTransaction",
      header: "Current Stock",
      sortable: true,
      filter: false,
    },

    // 📌 Stock Details
    {
      field: "stockDetails.unitPrice",
      header: "Unit Price",
      sortable: true,
      filter: false,
      body: (rowData: any) => rowData.stockDetails?.unitPrice || "-",
    },
    {
      field: "stockDetails.totalPrice",
      header: "Total Price",
      sortable: true,
      filter: false,
      body: (rowData: any) => rowData.stockDetails?.totalPrice || "-",
    },
    {
      field: "stockDetails.originalMfg",
      header: "Original Mfg",
      sortable: true,
      filter: false,
      body: (rowData: any) => rowData.stockDetails?.originalMfg || "-",
    },
    {
      field: "stockDetails.modelPartNo",
      header: "Model/Part No",
      sortable: true,
      filter: false,
      body: (rowData: any) => rowData.stockDetails?.modelPartNo || "-",
    },
    {
      field: "stockDetails.stockCategory",
      header: "Stock Category",
      sortable: true,
      filter: false,
      body: (rowData: any) => rowData.stockDetails?.stockCategory || "-",
    },
    {
      field: "stockDetails.location",
      header: "Rack Location",
      sortable: true,
      filter: false,
      body: (rowData: any) => rowData.stockDetails?.location || "-",
    },

    // 📌 Location Info

    // 📌 PO / Comments / Supplier
    {
      field: "po",
      header: "PO",
      sortable: true,
      filter: true,
    },
    {
      field: "comments",
      header: "Comments",
      sortable: true,
      filter: false,
    },
    {
      field: "supplierName",
      header: "Supplier Name",
      sortable: true,
      filter: true,
    },

    // 📌 Asset Info
    {
      field: "assetInfo.familyName",
      header: "Asset-Familyname",
      sortable: true,
      filter: false,
      body: (rowData: any) => rowData.assetInfo?.familyAssetId || "-",
    },
    {
      field: "assetInfo.assetName",
      header: "Asset-Assetname",
      sortable: true,
      filter: false,
      body: (rowData: any) => rowData.assetInfo?.assetName || "-",
    },


    // 📌 Capex Info
    {
      field: "capexInfo.capexRefNum",
      header: "Capex-Ref Number",
      sortable: true,
      filter: false,
      body: (rowData: any) => rowData.capexInfo?.capexRefNum || "-",
    },
    {
      field: "capexInfo.harmonyCode",
      header: "Capex-Harmony Code",
      sortable: true,
      filter: false,
      body: (rowData: any) => rowData.capexInfo?.harmonyCode || "-",
    },


    // 📌 Project Info

    {
      field: "projectInfo.locationName",
      header: "Project-Country",
      sortable: true,
      filter: true,
      body: (rowData: any) => rowData.projectInfo?.locationName || "-",
    },

    {
      field: "projectInfo.regionName",
      header: "Project-Region",
      sortable: true,
      filter: true,
      body: (rowData: any) => rowData.projectInfo?.regionName || "-",
    },
    {
      field: "projectInfo.projectName",
      header: "Project-Project Name",
      sortable: true,
      filter: true,
      body: (rowData: any) => rowData.projectInfo?.projectName || "-",
    },

    // 📌 Store Transfer Info

    {
      field: "storeTransfer.sourceLocationName",
      header: "Store-Country",
      sortable: true,
      filter: false,
      body: (rowData: any) => rowData.storeTransfer?.sourceLocationName || "-",
    },
    {
      field: "storeTransfer.sourceStoreName",
      header: "Source-Store",
      sortable: true,
      filter: false,
      body: (rowData: any) => rowData.storeTransfer?.sourceStoreName || "-",
    },

    // 📌 Audit Fields
    {
      field: "createdAt",
      header: "Created At",
      sortable: true,
      filter: false,
      body: (rowData: any) =>
        rowData.createdAt ? new Date(rowData.createdAt).toLocaleString() : "-",
    },
    {
      field: "createdBy",
      header: "Created By",
      sortable: true,
      filter: true,
      body: (rowData: any) => rowData.createdBy || "-",
    },

    // 📌 Actions
    {
      field: "actions",
      header: "Actions",
      body: actionBodyTemplate,
      exportable: false,
      sortable: false,
      filter: false,
    },
  ];



export const getStockColumnn = (
  actionBodyTemplate: (rowData: stockTypes) => JSX.Element,
  actionPicTemplate: (rowData: any) => JSX.Element
): ColumnProps[] => [
    {
      selectionMode: "multiple",
      exportable: false,
    },
    {
      field: "stockAttachmentId",
      header: "Image",
      sortable: false,
      filter: false,
      body: actionPicTemplate,
    },
    {
      field: "stockCode",
      header: "Stock Code",
      sortable: true,
      filter: false,
      filterField: "stockCode",
      filterPlaceholder: "Search",
    },
    {
      field: "stock_description",
      header: "Item Description",
      sortable: true,
      filter: false,
      filterField: "stock_description",
      filterPlaceholder: "Search",
    },
    {
      field: "location_name",
      header: "Country",
      sortable: true,
      filter: false,
      filterField: "location_name",
      filterPlaceholder: "Search",
    },
    {
      field: "localStore",
      header: "Local Stores",
      sortable: true,
      filter: false,
      filterField: "localStore",
      filterPlaceholder: "Search",
    },
    {
      field: "original_mfg",
      header: "Original Mfg",
      sortable: true,
      filter: false,
      filterField: "original_mfg",
      filterPlaceholder: "Search",
    },
    {
      field: "model_part_no",
      header: "Model/Part no",
      sortable: true,
      filter: false,
      filterField: "model_part_no",
      filterPlaceholder: "Search",
    },
    {
      field: "stock_category",
      header: "Stock Category",
      sortable: true,
      filter: false,
      filterField: "stock_category",
      filterPlaceholder: "Search",
    },
    {
      field: "used_for_mfg",
      header: "Used for - Mfg",
      sortable: false,
      filter: false,
      body: (rowData: any) => rowData.used_for_mfg || "-", // Show value or fallback
    },
    {
      field: "used_for_model",
      header: "Used for - Model",
      sortable: false,
      filter: false,
      body: (rowData: any) => rowData.used_for_model || "-", // Show value or fallback
    },

    {
      field: "supplier",
      header: "Supplier",
      sortable: true,
      filter: false,
      filterField: "supplier",
      filterPlaceholder: "Search",
    },
    {
      field: "location",
      header: "Rack Location",
      sortable: true,
      filter: false,
      filterField: "location",
      filterPlaceholder: "Search",
    },
    {
      field: "currentStock",
      header: "Current Stock",
      sortable: true,
      filter: false,
      filterField: "currentStock",
      filterPlaceholder: "Search",
    },
    {
      field: "qty",
      header: "Qty",
      sortable: true,
      filter: false,
      filterField: "qty",
      filterPlaceholder: "Search",
    },
    {
      field: "unit_price",
      header: "Unit Price",
      sortable: true,
      filter: false,
      filterField: "unit_price",
      filterPlaceholder: "Search",
    },
    {
      field: "total_price",
      header: "Total Price",
      sortable: true,
      filter: false,
      filterField: "total_price",
      filterPlaceholder: "Search",
    },

    {
      field: "currency",
      header: "Currency",
      sortable: true,
      filter: false,
      filterField: "currency",
      filterPlaceholder: "Search",
    },
    {
      body: actionBodyTemplate,
      exportable: false,
    }
  ];

export const getStockColumn = (
  actionBodyTemplate: (rowData: stockTypes) => JSX.Element,
  actionPicTemplate: (rowData: any) => JSX.Element
): ColumnProps[] => [
    {
      selectionMode: "multiple",
      exportable: false,
    },
    {
      field: "stockAttachmentId",
      header: "Image",
      sortable: false,
      filter: false,
      body: actionPicTemplate,
    },
    {
      field: "stockCode",
      header: "Stock Code",
      sortable: true,
      filter: false,
      filterField: "stockCode",
      filterPlaceholder: "Search",
    },
    {
      field: "stock_description",
      header: "Item Description",
      sortable: true,
      filter: false,
      filterField: "stock_description",
      filterPlaceholder: "Search",
    },
    {
      field: "location_name",
      header: "Country",
      sortable: true,
      filter: false,
      filterField: "location_name",
      filterPlaceholder: "Search",
    },
    // {
    //   field: "localStore",
    //   header: "Local Stores",
    //   sortable: true,
    //   filter: false,
    //   filterField: "localStore",
    //   filterPlaceholder: "Search",
    // },
    // {
    //   field: "original_mfg",
    //   header: "Original Mfg",
    //   sortable: true,
    //   filter: false,
    //   filterField: "original_mfg",
    //   filterPlaceholder: "Search",
    // },
    {
      field: "model_part_no",
      header: "Model/Part no",
      sortable: true,
      filter: false,
      filterField: "model_part_no",
      filterPlaceholder: "Search",
    },
    {
      field: "stock_category",
      header: "Stock Category",
      sortable: true,
      filter: false,
      filterField: "stock_category",
      filterPlaceholder: "Search",
    },
    {
      field: "used_for_mfg",
      header: "Used for - Mfg",
      sortable: false,
      filter: false,
      body: (rowData: any) => rowData.used_for_mfg || "-", // Show value or fallback
    },
    {
      field: "used_for_model",
      header: "Used for - Model",
      sortable: false,
      filter: false,
      body: (rowData: any) => rowData.used_for_model || "-", // Show value or fallback
    },

    {
      field: "supplier",
      header: "Supplier",
      sortable: true,
      filter: false,
      filterField: "supplier",
      filterPlaceholder: "Search",
    },
    // {
    //   field: "location",
    //   header: "Rack Location",
    //   sortable: true,
    //   filter: false,
    //   filterField: "location",
    //   filterPlaceholder: "Search",
    // },
    {
      field: "currentStock",
      header: "Current Stock",
      sortable: true,
      filter: false,
      filterField: "currentStock",
      filterPlaceholder: "Search",
    },
    // {
    //   field: "qty",
    //   header: "Qty",
    //   sortable: true,
    //   filter: false,
    //   filterField: "qty",
    //   filterPlaceholder: "Search",
    // },
    // {
    //   field: "unit_price",
    //   header: "Unit Price",
    //   sortable: true,
    //   filter: false,
    //   filterField: "unit_price",
    //   filterPlaceholder: "Search",
    // },
    // {
    //   field: "total_price",
    //   header: "Total Price",
    //   sortable: true,
    //   filter: false,
    //   filterField: "total_price",
    //   filterPlaceholder: "Search",
    // },

    // {
    //   field: "currency",
    //   header: "Currency",
    //   sortable: true,
    //   filter: false,
    //   filterField: "currency",
    //   filterPlaceholder: "Search",
    // },
  ];

